module.exports = __webpack_public_path__ + "img/curved-arrow-icon.72f97079.svg";